<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Jenis & Harga Iklan Digital
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col lg="3">
            <b-input-group >
                <b-input-group-prepend><span class="pt-2 mr-2">Item Name</span></b-input-group-prepend>
                <b-form-input v-model="tblData.jenisiklan" ></b-form-input>
            </b-input-group>
        </b-col>
        <b-col md="7">
            <b-input-group >
                <b-input-group-prepend><span class="pt-2 mr-2">Platform</span></b-input-group-prepend>
                <b-form-select v-model="tblData.platform" :plain="true" :options="platforms"></b-form-select>
                <b-input-group-prepend><span class="pt-2 mr-2">Position</span></b-input-group-prepend>
                <b-form-input v-model="tblData.posisi" ></b-form-input>
                <b-input-group-append>
                      <b-button variant="success" size="sm" @click="search()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
                </b-input-group-append>
                <b-input-group-append>
                      <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
                </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(index)="data">
          {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
        </template>

        <template v-slot:cell(harga)="data">
          {{data.item.harga|numFormat}}
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing
            {{(tblData.page - 1) * tblData.limit + 1}}
            to
            {{tblData.page * tblData.limit}}
            of
            {{tblData.total}}
            entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page"  style="margin-top:0 !important;">
            <b-form-select :options="[10, 15, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-form-group>
        </b-col>        

        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card >
          <div slot="header">Jenis & Harga Iklan - Add/Edit Form 
          </div>
                <b-input-group >
                    <b-input-group-prepend><label>Platform</label></b-input-group-prepend>
                    <b-form-select v-model="frmdata.platformid" :plain="true" :options="platforms" :state="!$v.frmdata.platformid.$error"></b-form-select>
                </b-input-group>

                <b-input-group >
                    <b-input-group-prepend><label>Jenis Iklan</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.jenisiklan" :state="!$v.frmdata.jenisiklan.$error"></b-form-input>
                </b-input-group>
                  <b-input-group >
                    <b-input-group-prepend><label>Konten Iklan</label></b-input-group-prepend>
                    <b-form-select v-model="frmdata.konteniklan" :plain="true" :options="konteniklans" :state="!$v.frmdata.konteniklan.$error"></b-form-select>
                  </b-input-group>                      
                <b-input-group >
                    <b-input-group-prepend><label>Ukuran & Posisi</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.ukuranposisi"  ></b-form-input>
                </b-input-group>
                <b-input-group >
                    <b-input-group-prepend><label>Page/Chanel</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.halamanposisi" ></b-form-input>
                </b-input-group>
                <b-row>
                   <b-col lg="8">
                      <b-input-group >
                          <b-input-group-prepend><label>Harga (rate card) </label></b-input-group-prepend>
                              <b-input-group-prepend>
                                  <span class="input-group-text">{{uanguser}}</span>
                              </b-input-group-prepend>
                              <my-number class="form-control text-right" v-model="frmdata.harga" :precision="2" :state="!$v.frmdata.harga.$error"></my-number>
                      </b-input-group>
                   </b-col>
                </b-row>
                <b-input-group >
                    <b-input-group-prepend><label>Uraian</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.uraian"  ></b-form-input>
                </b-input-group>
                
            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
              <b-button class="btn btn-danger mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>

        </b-card>
        </b-col>
    </b-row>
  </div>
</template>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 160px;
            }
        }
    }
</style>


<script>
import toastr from "mini-toastr";
import jiklandigital from "../../apis/jiklandigital";
import myNumber from "../../components/my-number";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        jenisiklan: { required },
        platformid: { required },
        harga: { required },
        ukuranposisi: { required },
        konteniklan: { required },
    },
  }, 
  components:{myNumber},
  data() {
    return {
      showDelConfirm: false,
      showList:true,
      showForm:false,
      uanguser: this.$store.state.user.matauang,
      frmdata:{jenisiklan: '',uraian:'' , harga:0},
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'jenisiklan',
        sortDesc: false
      },
      platforms:[{value:'', text:'-- ALL --'}],
      konteniklans:['Text', 'Foto', 'Video', 'Live TV']

    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "index",
            label: "No.",
          },
          {
            key: "platform",
            label: "Platform",
            sortable: true
          },
          {
            key: "jenisiklan",
            label: "Inventory",
            sortable: true
          },
          {
            key: "ukuranposisi",
            label: "Size & Position",
            sortable: true
          },
          {
            key: "halamanposisi",
            label: "Page/Canal ",
            sortable: true
          },
          {
            key: "konteniklan",
            label: "Content Type",
            sortable: true
          },
          {
            key: "uraian",
            label: "Remarks",
            sortable: true
          },
          {
            key: "harga",
            label: "Harga",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  created: async function() {
    const plt = await  await jiklandigital.platform();
     this.platforms = this.platforms.concat(plt);
  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await jiklandigital.list(this.tblData);      
      return list;
    },
    search() {
      this.tblData.page=1;
      this.refresh();
    },    
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.jenisiklan= '';
        this.tblData.platform= '';
        this.tblData.posisi= '';
        this.refresh();
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.idlama = data.jiklanid;
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              // await programtv.save(this.frmdata)
              this.tblData.platform= this.frmdata.platformid;
              await jiklandigital.save(this.frmdata);
              toastr.success(`Success, Number`, "Save Jenis Iklan",10000);

              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
            try {
              await jiklandigital.remove(this.model);
              toastr.success(`Complete Successfully`, "Delete Jenis Iklan",10000);

              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
            }

    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push({name: "iklankoran.home"});
    },    
  }
};
</script>
